<div class="layout-col full">
  <mat-toolbar class="layout-row place-between-center gap-sm" elderTheme>
    <div class="layout-row place-start-center gap-sm">
      <button mat-icon-button matDialogClose>
        <mat-icon>close</mat-icon>
      </button>
      <span>{{ 'manufacturing.routes.select' | translate }}</span>
    </div>
    <button mat-button (click)="onShowAllRoutesChange()">
      {{
        (showAllProdRoutes
          ? 'manufacturing.routes.hide-unavailable'
          : 'manufacturing.routes.show-all'
        ) | translate
      }}
    </button>
  </mat-toolbar>

  <app-schedule-select-route-table
    class="flex p-sm"
    [items]="selectedItems$ | async"
    [showAllRoutes]="showAllRoutes$ | async"
    (itemsModifiedIds)="onItemsModified($event)"
  >
  </app-schedule-select-route-table>
</div>
